import api from "api";

const UserActivityDto = {
  HealthPlanKey: "",
  PolicyKey: "",
  EventStream: "",
  StatusCode: "UI",
  Source: "",
  WorkFlow: "",
  Page: window.location.href,
  AppCreateDatetime: new Date().toISOString(),
};

/**
 * Posts a user activity event to the backend API.
 *
 * @param {string} healthPlanKey - The health plan key associated with the activity.
 * @param {string} policyKey - The policy key associated with the activity.
 * @param {string} statusCode - The status code for API Call you are recording aCtivity for.
 * @param {string} workflow - contained in constants/Constants.js
 * @param {string} eventType - The type of event (e.g., "click", "view").
 * @param {string} component - The component where the event occurred.
 * @param {string} action - The action performed by the user.
 * @param {string} target - The target element or entity of the action.
 * @returns {Promise<Object>} The API response.
 * @throws Will throw an error if the API call fails.
 * @example
 * try {
 *   await postUserActivity(...);
 * } catch (error) {
 *   dispatch(
 *     setDialog({
 *       title: "Error",
 *       message: formErrorStrfromObj(error),
 *     })
 *   );
 * }
 */
export const postUserActivity = async (
  HealthPlanKey,
  PolicyKey,
  StatusCode,
  WorkFlow,
  eventType,
  component,
  action,
  target,
  activityUpdates
) => {
  const eventStream = {
    eventType: eventType,
    component: component,
    action: action,
    target: target,
  };

  const userActivityDto = {
    healthPlanKey: HealthPlanKey == null ? 999 : HealthPlanKey,
    policyKey: PolicyKey == null ? 1 : PolicyKey,
    eventStream: JSON.stringify(eventStream),
    statusCode: StatusCode,
    source: "UI",
    workflow: WorkFlow,
    page: window.location.href,
    appCreateDatetime: new Date()
      .toISOString()
      .replace("T", " ")
      .substring(0, 19), // "yyyy-MM-dd HH:mm:ss" utc format
  };

  let userActivityDtoArray = [userActivityDto];

  if (activityUpdates && activityUpdates.length > 0) {
    userActivityDtoArray.push(...activityUpdates);
  }
  try {
    const response =
      await api.UserActivity.postNonClobUserActivity(userActivityDtoArray);
    if (!response || response.status !== 200) {
      throw new Error("Failed to post user activity");
    }
    return response;
  } catch (error) {
    // Handle or log the error as needed
    console.error("Failed to post user activity:", error);
    throw error;
  }
};

/**
 * Posts user activity for CLOB procedure, diagnosis, and coverageControl changes.
 * @param {Array} userActivityDtoArray - The array of user activity DTOs to post.
 * @returns {Promise<Object>} The API response.
 * @throws Will throw an error if the API call fails.
 */
export const postClobUserActivityCodeChanges = async (userActivityDtoArray) => {
  try {
    const response =
      await api.UserActivity.postClobUserActivity(userActivityDtoArray);
    if (!response || response.status !== 200) {
      throw new Error("Failed to post user activity");
    }
    return response;
  } catch (error) {
    // Handle or log the error as needed
    console.error("Failed to post user activity:", error);
    throw error;
  }
};
